/* eslint-disable */
import React, { useState, useRef, useEffect } from "react";
import Popup from "reactjs-popup";
import { getDashcamPublishedReports } from "../../../actions";
import Scrollbars from "react-custom-scrollbars";
import moment from "moment";
import { connect } from "react-redux";
import Statistics from "../../Statistics";

const REACTION_EMOJI = { like: "👍", rofl: "🤣", wow: "😮", angry: "😠" };

const ReactionsPopup = ({ row }) => {
  const reactions = row?.reactions || {};
  const views = reactions?.views ?? row?.views ?? "---";
  const hasBreakdown = reactions?.like != null || reactions?.rofl != null || reactions?.wow != null || reactions?.angry != null;

  return (
    <div style={{ padding: "10px 14px", minWidth: "140px", fontSize: "13px" }}>
      {hasBreakdown && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "8px 14px", marginBottom: "8px" }}>
          {reactions?.like != null && <span>{REACTION_EMOJI.like} {reactions.like}</span>}
          {reactions?.rofl != null && <span>{REACTION_EMOJI.rofl} {reactions.rofl}</span>}
          {reactions?.wow != null && <span>{REACTION_EMOJI.wow} {reactions.wow}</span>}
          {reactions?.angry != null && <span>{REACTION_EMOJI.angry} {reactions.angry}</span>}
        </div>
      )}
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "12px",
        paddingTop: hasBreakdown ? "8px" : 0,
        borderTop: hasBreakdown ? "1px solid #d2e0fa" : "none",
      }}>
        {reactions?.total != null && <span style={{ fontWeight: "bold" }}>Total: {reactions.total}</span>}
        <span>Views: {views}</span>
      </div>
    </div>
  );
};

const headerElements = [
  { name: "User", width: "33%" },
  { name: "Video title", width: "50%" },
  { name: "Number of feed reactions", width: "17%" },
];

const DashcamPublishedReports = ({ getDashcamPublishedReports, dashcamPublishedReports, period, loading, setLoading, filtered }) => {
  const [curPage, setCurPage] = useState(2);
  const tableRef = useRef();
  const [innerLoading, setInnerLoading] = useState(false);
  const tableWidth = window.innerWidth < 1200 ? "160%" : "100%";

  const handleUpdate = (values) => {
    const { scrollTop, scrollHeight, clientHeight } = values;
    const pad = 0;
    const scrollableHeight = scrollHeight - clientHeight;
    if (scrollableHeight <= 0) return;
    const t = (Math.round(scrollTop) + pad) / scrollableHeight;
    if (t >= 0.97 && dashcamPublishedReports.totalPages >= curPage && !innerLoading) {
      setInnerLoading(true);
      getDashcamPublishedReports({
        pageNumber: curPage,
        limit: 10,
        ...period,
        createdAtFrom: period?.createdAtFrom || moment("2020-07-21").startOf("day").toISOString(),
        createdAtTo: period?.createdAtTo || moment().endOf("day").toISOString(),
        onSuccess: (res) => setInnerLoading(false),
      });
      setCurPage(curPage + 1);
    }
  };

  useEffect(() => {
    if (filtered) return;
    setLoading(true);
    getDashcamPublishedReports({
      pageNumber: 1,
      limit: 10,
      ...period,
      createdAtFrom: period?.createdAtFrom || moment("2020-07-21").startOf("day").toISOString(),
      createdAtTo: period?.createdAtTo || moment().endOf("day").toISOString(),
      onSuccess: (res) => {
        setLoading(false);
        setCurPage(2);
      },
    });
  }, []);

  useEffect(() => {
    if (filtered) {
      setLoading(true);
      getDashcamPublishedReports({
        pageNumber: 1,
        limit: 10,
        ...period,
        createdAtFrom: period?.createdAtFrom || moment("2020-07-21").startOf("day").toISOString(),
        createdAtTo: period?.createdAtTo || moment().endOf("day").toISOString(),
        onSuccess: (res) => {
          setLoading(false);
          setCurPage(2);
        },
      });
    }
  }, [period, filtered]);

  return (
    <>
      {loading === true ? (
        <div style={{ height: "90%" }}>{<Statistics.LoaderInline center />}</div>
      ) : (
        <>
          <div style={{ marginBottom: "15px", width: tableWidth }}>
            <h2 style={{ textTransform: "uppercase" }}>Dash Cam published reports</h2>
          </div>
          <Scrollbars
            style={{ height: "92%", width: tableWidth }}
            onUpdate={handleUpdate}
            ref={tableRef}
            id={"scrollbar-published"}
            renderView={(props) => <div {...props} style={{ ...props.style, overflowX: "hidden" }} />}
          >
            <div className="table-header">
              {headerElements?.map((header, i) => (
                <div className="header-cont" key={i} style={{ width: header.width }}>
                  <div className="header">{header.name}</div>
                </div>
              ))}
            </div>
            {dashcamPublishedReports?.docs?.map((row, i) => (
              <div className="table-body-row" key={row?._id || i}>
                <div className="row-data" style={{ width: "33%" }}>{row?.fullName || "---"}</div>
                <div className="row-data" style={{ width: "50%", wordBreak: "break-word", textTransform: "none" }} title={row?.title}>{row?.title || "---"}</div>
                <Popup
                  trigger={
                    <div className="row-data pointer" style={{ width: "17%" }}>{row?.reactions?.total ?? "---"}</div>
                  }
                  on={["hover", "focus"]}
                  position="left center"
                  className="anvil"
                  contentStyle={{ padding: 0, border: "1px solid #002c78", borderRadius: "8px" }}
                >
                  <ReactionsPopup row={row} />
                </Popup>
              </div>
            ))}
            {innerLoading && (
              <div className="inner-loader-container">
                <Statistics.LoaderInline center />
              </div>
            )}
          </Scrollbars>
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  dashcamPublishedReports: state.app.dashcamPublishedReports,
});
const mapDispatchToProps = (dispatch) => ({
  getDashcamPublishedReports: (payload) => dispatch(getDashcamPublishedReports(payload)),
});
export default connect(mapStateToProps, mapDispatchToProps)(DashcamPublishedReports);
